// FileUploadDialog.jsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress
} from "@material-ui/core";

const FileUploadDialog = ({
  isOpen,
  onClose,
  handleFileChange,
  handleFileUpload,
  loading
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Upload File</DialogTitle>
      <DialogContent>
        <input type="file" accept=".csv, .xls, .xlsx" onChange={handleFileChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={{ backgroundColor: "red", color: "white" }}>
          Cancel
        </Button>
        <Button 
          onClick={handleFileUpload} 
          disabled={loading} 
          style={{ backgroundColor: "#0B194A", color: "white" }}
        >
          {loading ? <CircularProgress size={20} style={{ color: "white" }} /> : "Upload"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileUploadDialog;